import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { Item } from '../../../components/Item';
import { WsDialog, WsDialogSize } from '../../../components/WsDialog';
import { WsTypography, WsTypoVariants } from '../../../components/WsTypography';
import WsColors from '../../../WsColors';

type InvalidEmailDataType = {
  openInvalidWarning: boolean;
  noEmail: boolean;
  onCloseHandler(): void;
};
const InvalidEmailData = ({
  openInvalidWarning,
  noEmail,
  onCloseHandler,
}: InvalidEmailDataType) => {
  return (
    <WsDialog openDialog={openInvalidWarning} size={WsDialogSize.SMALL}>
      <>
        <CloseIcon
          sx={{ cursor: 'pointer', marginLeft: '94%', marginTop: '1%', color: WsColors.Red500 }}
          fontSize={'small'}
          onClick={() => onCloseHandler()}
        />
        <Item sx={{ pt: 0 }}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>
            {`${noEmail ?? ' Email not available, Update  email to send Email'}`}
          </WsTypography>
        </Item>
      </>
    </WsDialog>
  );
};

export default InvalidEmailData;
